// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"dE-z","tooltipWrapper":"eE-z","icon":"fE-z","tooltip":"gE-z","content":"hE-z"};